import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import getLandingPageData from 'store/landing/selector/getLandingPageData';
import { LandingPageProvider } from 'context/LandingPageContext';
import LandingPageBuilder from 'components/LandingPage/Factory/LandingPageBuilder';
import fetchNoResultsContentOperation from 'store/search/operation/fetchNoResultsContentOperation';
import styles from './NoHighlights.module.scss';
import BringBackMemories from '../BringBackMemories/BringBackMemories';

const NoHighlights = () => {
  const dispatch = useDispatch();
  const landingPageData = useSelector(getLandingPageData);

  useEffect(() => {
    dispatch(fetchNoResultsContentOperation());
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <BringBackMemories description="txt_no_personalised_items" />
      </div>
      <div className={styles.lpContainer}>
        {landingPageData && landingPageData.content && (
          <LandingPageProvider>
            <LandingPageBuilder landingPageData={landingPageData} />
          </LandingPageProvider>
        )}
      </div>
    </div>
  );
};

export default NoHighlights;
